import { render, staticRenderFns } from "./pro_content.vue?vue&type=template&id=78107a3a&"
import script from "./pro_content.vue?vue&type=script&lang=js&"
export * from "./pro_content.vue?vue&type=script&lang=js&"
import style0 from "./pro_content.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports